<template>
  <div class="oooItem">
    <template>
      <div v-if="item.contents" class="ibox">
        <div class="ibox-content">
          <!-- 1on1Component2 -->
          <div v-for="count in checkContent1on1" :key="count.id" id="one-item2" class="ibox-child">
            <div class="flex-box cursor">
              <img class="one-icon" :src="'static/img/1on1/img0' + count + '.png'" alt="">
              <div class="comment">
                <div class="flex-box fl-between">
                  <h4 class="h3">{{contentTypeLabel[count-1]}}</h4>
                </div>
                <one-item :detailView="true" :item="item.contents[count-1]" :oneId="item.itemId + (count - 1)"/>
              </div>
            </div>
            <div class="flex-box comment-wrap cursor" @click="onClickShowComment(count - 1)">
              <div class="info-comment-detail">
                <img class="info-icon" src="static/img/assets/comment.png">
                <span>{{ getCommentsByItemId(item.itemId, '1on1s_' + [count-1]).length }}</span>
                  <img class="star" v-if="isOneLiked(item.likes,count-1)":src="'static/img/assets/nice_on.png'">
                  <img class="star" v-else :src="'static/img/assets/nice_off.png'">
                  <span class="like-counter" v-if="!!item && !!item.likes &&!!item.likes[count-1]"><strong>{{ item.likes[count-1] ? Object.keys(item.likes[count-1]).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
              </div>
              <label class="cursor">
                <i :class="{'chevronUp' : getTargetType === '1on1s_' + (count - 1)}" class="fa fa-chevron-down"></i>
              </label>
            </div>
            <div :class="{'comment-active': getTargetType === '1on1s_' + (count - 1)}" class="content-wrapper">
              <div class="ib-sub-content">
                <div class="panel-body">
                  <div v-if="!getTargetAllComments[count - 1][0]" class="comment-view ibox-child">{{$t('stillNotCommentStr')}}</div>
                  <div class="comment-view">
                    <template v-for="obj in getTargetAllComments[count - 1]">
                      <div :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                        <comment-item :propComment="obj" />
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// import moment from 'moment'
import { mapGetters } from 'vuex'
import CommentItem from '@/components/Comment/CommentItem'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import OneItem from '@/components/One/OneItem'
import { content1on1 } from '@/main'

export default {
  name: 'Report1on1Item',
  props: ['item'],
  components: {
    CommentItem,
    OneItem,
    ReadMore
  },
  data: function () {
    return {
      uid: this.uid,
      ooo: this.item,
      types: '',
      src: '',
      type: '',
      time: this.item.createdAt,
      timestamp: '',
      targetOneItemKey: '',
      targetType: '',
      propShowMore: false,
      propShowMore1: false,
      propShowMore2: false,
      propShowMore3: false,
      content1on1: content1on1
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    contentTypeLabel () {
      return {
        0: this.$t('firstContent1on1'),
        1: this.$t('secondContent1on1'),
        2: this.$t('thirdContent1on1'),
        3: this.$t('forthContent1on1'),
        notes: this.$t('memoContent1on1')
      }
    },
    contentType () {
      return [
        {
          label: this.$t('firstContent1on1'),
          image: 'static/img/1on1/img02.png'
        },
        {
          label: this.$t('secondContent1on1'),
          image: 'static/img/1on1/img01.png'
        },
        {
          label: this.$t('thirdContent1on1'),
          image: 'static/img/1on1/img03.png'
        },
        {
          label: this.$t('forthContent1on1'),
          image: ''
        }
      ]
    },
    contentNotes () {
      return {
        label: this.$t('memoContent1on1'),
        image: 'static/img/1on1/img05.png'
      }
    },
    checkContent1on1 () {
      return Object.keys(content1on1.content1on1).length
    },
    getTargetComments () {
      return this.getCommentsByItemId(this.getTargetOneItemKey, this.getTargetType)
    },
    getTargetAllComments () {
      let comments = {
        0: this.getCommentsByItemId(this.getTargetOneItemKey, '1on1s_0'),
        1: this.getCommentsByItemId(this.getTargetOneItemKey, '1on1s_1'),
        2: this.getCommentsByItemId(this.getTargetOneItemKey, '1on1s_2'),
        3: this.getCommentsByItemId(this.getTargetOneItemKey, '1on1s_3')
      }
      return comments
    },
    getTargetType: {
      get: function () {
        return this.targetType
      },
      set: function (value) {
        this.targetType = value
      }
    },
    getTargetOneItemKey () {
      return this.item.itemId
    }
  },
  created: function () {
    console.log(this.item)
  },
  methods: {
    reviewOf: function (date) {
      console.log('reviewOf:', date)
      let ymd = (date || '').split('/')
      let dateFormatted = this.$t('noticeDateFormat')
        .replace('{$y}', (ymd[0] || '----'))
        .replace('{$m}', (ymd[1] || '--'))
        .replace('{$d}', (ymd[2] || '--'))
      return this.$t('retrospectiveStr').replace('{$date}', dateFormatted)
    },
    clickReadMore (index) {
      console.log('clickReadMore', index)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateShowMore1: function (value) {
      this.propShowMore1 = value
    },
    updateShowMore2: function (value) {
      this.propShowMore2 = value
    },
    updateShowMore3: function (value) {
      this.propShowMore3 = value
    },
    onClickShowComment: function (index) {
      if (this.getTargetType === '1on1s_' + index) this.getTargetType = '1on1s_'
      else this.getTargetType = '1on1s_' + index
    },
    isOneLiked: function (likes, number) {
      if (!likes || !likes.hasOwnProperty(number)) {
        return false
      } else {
        return Object.keys(likes[number]).filter(x => x === this.getUserId).length !== 0
      }
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a:hover{
  text-decoration: none;
}
.oooItem {
    background: #fff;
    color: #333;
    padding: .5em 1em;
}
.icon1on1type {
  width: 1em;
}
.chevronUp{
  transform: rotate(180deg);
}
.comment-wrap {
  justify-content: flex-end;
  margin-bottom: 1rem;
  margin-top: 2rem;
  font-size: 0.9em;
}
.comment-wrap .cursor:hover{
  opacity: 0.5;
}
.content-wrapper {
  height: auto;
  max-height: 0;
  margin-top: 1rem;
  overflow-x: hidden;
  overflow-y: auto;
  transition: 0.4s all ease-in-out;
}
.content-wrapper.comment-active {
  height: auto;
  max-height: 30vh;
}
.star{
  width: 2.0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Report1on1Item.vue